
import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              {t('privacyPolicy.heroTitle')}
            </h1>
            <p className="text-xl text-gray-600">
              {t('privacyPolicy.lastUpdated')}
            </p>
          </div>
        </div>
      </section>

      {/* 政策内容 */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="prose prose-lg max-w-none">
            
            {/* 引言 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('privacyPolicy.introduction.title')}
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('privacyPolicy.introduction.p1')}
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('privacyPolicy.introduction.p2')}
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('privacyPolicy.introduction.p3')}
              </p>
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
                <p className="text-gray-800 font-semibold mb-2">
                  {t('privacyPolicy.introduction.important')}
                </p>
                <p className="text-gray-700">
                  {t('privacyPolicy.introduction.importantNote')}
                </p>
              </div>
              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicy.introduction.p4')}
              </p>
            </div>

            {/* 1. 我们收集的信息 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('privacyPolicy.section1.title')}
              </h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('privacyPolicy.section1.subsection1.title')}
              </h3>
              <p className="text-gray-700 mb-4">
                {t('privacyPolicy.section1.subsection1.p1')}
              </p>
              
              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">
                  {t('privacyPolicy.section1.subsection1.category1.title')}
                </h4>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  {(t('privacyPolicy.section1.subsection1.category1.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">
                  {t('privacyPolicy.section1.subsection1.category2.title')}
                </h4>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  {(t('privacyPolicy.section1.subsection1.category2.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>

              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">
                  {t('privacyPolicy.section1.subsection1.category3.title')}
                </h4>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  {(t('privacyPolicy.section1.subsection1.category3.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6">
                <p className="text-gray-800 font-semibold mb-2">
                  {t('privacyPolicy.section1.subsection1.warning')}
                </p>
                <p className="text-gray-700">
                  {t('privacyPolicy.section1.subsection1.warningNote')}
                </p>
              </div>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('privacyPolicy.section1.subsection2.title')}
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                {(t('privacyPolicy.section1.subsection2.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>

            {/* 2. 信息使用目的与处理原则 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('privacyPolicy.section2.title')}
              </h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('privacyPolicy.section2.subsection1.title')}
              </h3>
              <p className="text-gray-700 mb-4">
                {t('privacyPolicy.section2.subsection1.p1')}
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                {(t('privacyPolicy.section2.subsection1.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('privacyPolicy.section2.subsection2.title')}
              </h3>
              <p className="text-gray-700 mb-4">
                {t('privacyPolicy.section2.subsection2.p1')}
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                {(t('privacyPolicy.section2.subsection2.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>

            {/* 3. 数据安全与保护措施 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('privacyPolicy.section3.title')}
              </h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('privacyPolicy.section3.subsection1.title')}
              </h3>
              <p className="text-gray-700 mb-4">
                {t('privacyPolicy.section3.subsection1.p1')}
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                {(t('privacyPolicy.section3.subsection1.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('privacyPolicy.section3.subsection2.title')}
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                {(t('privacyPolicy.section3.subsection2.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>

            {/* 4. 数据共享与第三方 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('privacyPolicy.section4.title')}
              </h2>
              
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('privacyPolicy.section4.p1')}
              </p>
              
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('privacyPolicy.section4.p2')}
              </p>
              
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                {(t('privacyPolicy.section4.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('privacyPolicy.section4.subsection1.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicy.section4.subsection1.p1')}
              </p>
            </div>

            {/* 5. 您的权利 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('privacyPolicy.section5.title')}
              </h2>
              
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('privacyPolicy.section5.p1')}
              </p>
              
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                {(t('privacyPolicy.section5.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicy.section5.p2')}
              </p>
            </div>

            {/* 6. Cookies 与类似技术 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('privacyPolicy.section6.title')}
              </h2>
              
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('privacyPolicy.section6.p1')}
              </p>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('privacyPolicy.section6.subsection1.title')}
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                {(t('privacyPolicy.section6.subsection1.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicy.section6.p2')}
              </p>
            </div>

            {/* 7. 数据保留期限 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('privacyPolicy.section7.title')}
              </h2>
              
              <div className="overflow-x-auto">
                <table className="min-w-full border border-gray-300">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900 border-b border-gray-300">
                        {t('privacyPolicy.section7.table.dataType')}
                      </th>
                      <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900 border-b border-gray-300">
                        {t('privacyPolicy.section7.table.retentionPeriod')}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white">
                    <tr>
                      <td className="px-6 py-4 text-sm text-gray-700 border-b border-gray-200">
                        {t('privacyPolicy.section7.table.accountInfo')}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-700 border-b border-gray-200">
                        {t('privacyPolicy.section7.table.accountInfoPeriod')}
                      </td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-gray-700 border-b border-gray-200">
                        {t('privacyPolicy.section7.table.processingData')}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-700 border-b border-gray-200">
                        {t('privacyPolicy.section7.table.processingDataPeriod')}
                      </td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-gray-700 border-b border-gray-200">
                        {t('privacyPolicy.section7.table.systemLogs')}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-700 border-b border-gray-200">
                        {t('privacyPolicy.section7.table.systemLogsPeriod')}
                      </td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-gray-700">
                        {t('privacyPolicy.section7.table.legalData')}
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-700">
                        {t('privacyPolicy.section7.table.legalDataPeriod')}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="mt-4 text-sm text-gray-700">{t('privacyPolicy.section7.note')} <a href="https://damaya.cn/privacy" className="text-blue-700 underline" target="_blank" rel="noopener noreferrer">damaya.cn/privacy</a></p>
            </div>

            {/* 8. 国际数据传输 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('privacyPolicy.section8.title')}
              </h2>
              
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('privacyPolicy.section8.p1')}
              </p>
              
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                {(t('privacyPolicy.section8.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>

            {/* 9. 政策更新 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('privacyPolicy.section9.title')}
              </h2>
              
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('privacyPolicy.section9.p1')}
              </p>
              
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('privacyPolicy.section9.p2')}
              </p>
              
              <p className="text-gray-700 leading-relaxed">
                {t('privacyPolicy.section9.p3')}
              </p>
            </div>

            {/* 10. 联系我们 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('privacyPolicy.section10.title')}
              </h2>
              
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('privacyPolicy.section10.p1')}
              </p>
              
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('privacyPolicy.section10.p2')}
              </p>
              
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('privacyPolicy.section10.p3')}
              </p>
              
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700 font-semibold">
                  {t('privacyPolicy.section10.email')}
                </p>
              </div>
              
              <p className="text-gray-700 leading-relaxed mt-4">
                {t('privacyPolicy.section10.p4')}
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
